<template>
  <div>
    <h1 class="mb-0">Register</h1>

    <RegisterForm />
  </div>
</template>

<script>
import RegisterForm from "./Forms/RegisterForm.vue";

export default {
  name: "Register",
  components: { RegisterForm }
};
</script>
